import { useSyncExternalStore } from "react";
import { useAuth } from "@/context/AuthContext";

const KEY = "cashmy.company";
const subs = new Set();

export const setActiveCompany = (id) => {
  localStorage.setItem(KEY, id);
  subs.forEach((f) => f());
};

const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };

export const useActiveCompany = () => {
  const { user } = useAuth();
  const stored = useSyncExternalStore(subscribe, () => localStorage.getItem(KEY));
  const list = user?.companies || [];
  return list.find((c) => c.id === stored) || list[0] || null;
};
